import { inject, Injectable } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { PageLeavingService } from './page-leaving.service';

// The only code allowed to replace the document (lint enforces it), so every redirect marks the page as leaving first.
@Injectable({ providedIn: 'root' })
export class HardNavigationService {
  private readonly window = inject<Window>(WA_WINDOW);
  private readonly pageLeaving = inject(PageLeavingService);

  public assign(url: string): void {
    this.pageLeaving.markLeaving();
    // eslint-disable-next-line no-restricted-syntax -- this service is the one place allowed to navigate
    this.window.location.href = url;
  }

  public reload(): void {
    this.pageLeaving.markLeaving();
    // eslint-disable-next-line no-restricted-syntax -- this service is the one place allowed to navigate
    this.window.location.reload();
  }

  public submit(form: HTMLFormElement): void {
    this.pageLeaving.markLeaving();
    form.submit();
  }
}
